import * as CL from './TS_Classes'
import { Support, AjaxStdResponse, UploadResult, BsModal, Blocker, DateTimePicker } from './TS_Controls'
import { WhatToggle } from './TS_Classes';

import * as MOM from '../node_modules/moment/moment'


declare var Vue: any;
declare var axios: any;





Vue.component('vac-date', {
	data: function () {
		return {
		}
	},
	props: {
		Vac: {
			type: Object,
		},
		Ix: {
			type: Number,
		},
	},
	methods: {
	},
	template: '#vac-date-template'
})



Vue.component('onbehalf-uploader', {
	data: function () {
		return {
			Stage: 0,
			StudentFile: {},
			FileName: '',
			FileType: '',
			Combined: true,
			IsConfirmed: false,
			UploadedFile: '',

			uploadEndpoint: '/Specdev/viewpoint/UploadDoc.aspx',
			addItemEndpoint: '/Gallery/Additem.aspx',
			defaultCombine: true,
			uploadPrefix: '/images/ViewPointScreening/clients/',
			uploadSuffix: '/tests',
			maxSize: 10000, // in kbs
			supportedFormats: ['bmp', 'gif', 'jpeg', 'jpg', 'png', 'pdf'],
			confirmMessage: 'Please click the link and review your file before sending it to Viewpoint Screening.',

		}
	},
	props: {
		File: {
			type: Object,
		},
		Person: {
			type: Object,
			default: {},
		},
	},
	watch: {
		File: {
			handler: function (newValue: any, oldValue: any) {
				// Handle the property change here

				this.Stage = 0;
				this.ClearFile();
				this.SoftReset();

				if (newValue == null) {
				} else {
					this.StudentFile = newValue;
					this.Begin();
				}
				console.log('File sent here');
			},
			deep: true
		}
	},
	methods: {


		Begin: function (): void {
			/* CLICK OUR HIDDEN FILE UPLOADER */
			this.$refs.file.click();
		},

		UploadNewFile: function (): void {
		  this.ClearFile();
		  this.SoftReset();
			this.Begin();
		},

		ReceivesFile: function (): void {

			console.log('received file');
			var f = this.GetFileOnBehalf();

			this.FileName = f.name;
			this.Stage = 10;
		},

		

		GetFileOnBehalf: function (): any {
			return this.$refs.file.files[0];
		},


		CancelProcess: function (): void {
			console.log('Upload on behalf cancelled');
			this.Stage = 0;
			this.$emit('cancel');
		},

		UploadAndReview: function (): void {
			console.log('Upload and Review');

			let f = this.GetFileOnBehalf();

			let formData = new FormData();

			var ext = CL.Helper.GetFileExtension(f.name);
			var fn = CL.Helper.GetFilenameWithoutExtension(f.name);
			var san = CL.Helper.Sanitize(fn).substr(0, 50);

			var newName = san + "_" + Math.round(Math.random() * 10000) + "." + ext;

			var folder = this.uploadPrefix 
				+ this.StudentFile.ClientName + '/' 
				+ this.StudentFile.ContactID + this.uploadSuffix;

			formData.append("Filedata", f, newName);
			formData.append("folder", folder);
			formData.append("newfilename", newName);
			formData.append("fileType", this.StudentFile.ReqName);
			formData.append("combine", this.Combined);
			
			/// THE USER BEING IMPERSONATED
			formData.append("userid", this.Person.ContactID);

			console.log(formData, f);

			axios
				.post(this.uploadEndpoint, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					}
				})
				.then((resp: any) => {
					if (!resp.data.Success) {
						throw resp.data.ErrorMessage;
					}

					console.log("Upload completed");

					this.$emit("completed", resp.data);

					this.UploadedFile = resp.data.RelPath;

					this.Stage = 30;

					/// CLEARS THE UPLOADED FILE.
					// this.ClearFile();
				})
				.catch((errr: any) => {
					alert('Error: ' + errr);

					this.Stage = 10;
					//this.bam__.SNAC.Error(errr);
				})
				.then(() => {
					//this.bam__.WBM.TurnOff();
				});

				this.Stage = 35;

		},

		ClearFile: function (): void {
			this.$refs.file.value = '';
			this.FileName = '';
		},

		ReviewFile: function (): void {
			window.open(this.UploadedFile);
			this.IsConfirmed = true;
		},


		SaveFile: function (): void {

			if (!this.IsConfirmed) {
				alert(this.confirmMessage);
				return;
			}

			var dt = this.GetCurrentDate();

			var data =
			{
				"auth": "1",
				"cat": "file",
				"na": this.StudentFile.ReqName,
				"pi": this.UploadedFile,
				"it": this.StudentFile.ContactID,
				"ve": "approved",
				"dt1": dt, // date of upload
				"dt2": dt, // date of status

				"ma": this.StudentFile.ClientName,
				"up": this.Person.FName + ' ' + this.Person.LName,
				"end": "1", // add the item to the gallery, but don't push to the cart
			};


			var formData = this.PackageData(data);

			axios
				.post(this.addItemEndpoint, formData, {
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					}
				})
				.then((resp: any) => {
					console.log("Document upload completed.");

					this.Stage = 40;

					/*
					EXECUTING THE ON-COMPLETED-CALLBACK.
					*/
					var data = { DocRelPath: this.UploadedFile };
					if (this.onCompletedCallback)
						this.onCompletedCallback(data);

				})
				.catch((errr: any) => {
					alert('Error: ' + errr);
					this.Stage = 30;
				})
				.then(() => {
				});


			this.Stage = 35;

		},


		PackageData: function(data:any)
		{
		  /* 
		  CONVERTS A JSON OBJECT INTO A FormData OBJECT,
		  SO IT CAN BE POSTED AS AN NVC USING AXIOS
		  */ 
		  const form = new FormData()
		  for ( const key in data ) {
			form.append(key, data[key]);
		  }
		  return form;
		},



		GetCurrentDate: function () {
			var d = new Date();
			var curr_date = d.getDate();
			var curr_month = d.getMonth() + 1; //Months are zero based
			var curr_year = d.getFullYear();

			return curr_month + "/" + curr_date + "/" + curr_year;
		},



		SoftReset:function(){
		  this.Stage = 0
		  this.IsUploading = true;
		  this.IsConfirmed = false;
		  this.Combined = this.defaultCombine;
		},


		ProcessCompleted: function (): void {
			console.log('Upload on behalf completed');
			this.Stage = 0;
			this.$emit('success');
		},






	},
	template: '#onbehalf-uploader'
})






Vue.component('student-notes-uploader',
	{
		data: function () {
			return {
				dynid: "file_" + Math.random(),
				targetFolder: '/images/ViewPointScreening/student_notes_uploads/',
				uploaderEndpoint: '/CommonAssets/BTMUploader.aspx',
				uploads: Array(),
				uploading: false,
				value: Array(),
			}
		},
		methods: {

			AddFile: function () {
				/* PREVENT MORE UPLOADS DURING AN UPLOAD */
				if (this.uploading) return;

				this.GetFileInputField().click();
			},

			RemoveFile: function (f: any) {
				var ok = confirm('Are you sure you want to remove file ' + f.Name + ' ?');

				if (!ok) return;

				var iof = this.uploads.indexOf(f);
				this.uploads.splice(iof, 1);

			},

			GetFileInputField: function () {
				return this.$refs[this.dynid];
			},

			ClearFiles: function () {
				/// CLEARS THE UPLOADED FILES.
				this.GetFileInputField().value = "";
			},

			Upload: function (form: any, callback: (resp: UploadResult) => void): void {
				// this.bam__.WBM.TurnOn();

				var result: UploadResult = {
					Ok: false,
				}

				this.uploading = true;

				axios.post(this.uploaderEndpoint, form, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
					.then((resp: any) => {
						if (!resp.data.Success) {
							throw resp.data.ErrorMessage;
						}
						this.$emit("completed", resp.data);

						result.Ok = true;
						result.FilePath = resp.data.RelPath;
					})
					.catch((errr: string) => {
						result.Msg = errr;
					})
					.then(() => {
						if (callback) callback(result);
						this.uploading = false;
					});
			},


			HandleUpload: function () {

				/// ENDPOINT IS NOT NECESSARY HERE,
				/// BECAUSE WE ARE USING THE UPLOAD FUNCTION ONLY,
				/// WHICH UPLOADS TO A DIFFERENT ENDPOINT.
				//
				var fi = this.GetFileInputField();

				var uploadables = [];
				var errr = [];
				var thumbs = [];


				let thisFile = fi.files[0];

				let formData = new FormData();

				var ext = CL.Helper.GetFileExtension(thisFile.name);
				var fn = CL.Helper.CreateGuid();

				var newName = fn + '.' + ext;


				formData.append("files[0]", thisFile, newName);
				formData.append("folder", this.targetFolder);


				this.Upload(formData, (result: UploadResult) => {
					if (!result.Ok) {
						alert('Error uploading file: ' + result.Msg);
						return;
					}

					this.uploads.push({
						Name: thisFile.name,
						Path: result.FilePath,
					});

					this.$emit('input', this.uploads)

					this.ClearFiles();

				})

				return;



				// 	for (var n=0;n<fi.files.length;n++)
				// 	{
				// 		var thisFile = fi.files[n];

				// 		// var rb = this.ValidateFile(thisFile);

				// 		if (!rb.Ok){
				// 			if (errr.length>0) errr.push("");
				// 			errr.push(rb.Msg);
				// 			errr.push("File <strong>"+ thisFile.name +"</strong> will not be uploaded");
				// 		}else{

				// 			if (uploadables.length>=this.maxUploads){
				// 				errr.push(`A max of ${this.maxUploads} can be uploaded simultaneously. <strong>${thisFile.name}</strong> Will not be uploaded`);
				// 				continue;
				// 			}

				// 			uploadables.push(thisFile);


				// 			var oFReader = new FileReader();

				// 			/* STORE THE FILE WE ARE PROCESSING, INSIDE THE READER OBJECT,
				// 			OTHERWISE WE WON'T KNOW WHAT'S THE FILE WE ARE ACTING ON.
				// 			*/
				// 			(oFReader as any)["thefil"] = thisFile;

				// 				oFReader.onload = (oFREvent)=> {

				// 						var currFile = (oFREvent.target as any)["thefil"];

				// 						var u = new upie();
				// 						u.Name = currFile.name;
				// 						u.Type = CL.Helper.GetFileExtension(currFile.name);
				// 						u.Thumb = oFREvent.target.result as string;
				// 						u.IsImg = CL.Helper.IsImage(currFile.name)

				// 						thumbs.push(u);
				// 				};

				// 			oFReader.readAsDataURL(thisFile);

				// 		}

				// 	// }

				// }

			},

		},
		template: '#student-notes-uploader'
	});


export class VPS_CUST_DASHBOARD {

	private _cfg: CL.CartCfg;
	// private _cart: CL.Cart;
	private _vue: any;

	private _isBusy: boolean = false;
	private _blk: Blocker;
	private _mdl: BsModal = new BsModal({});

	private _maxToggles: number = 4;
	private _maxFilters: number = 10;

	private _impersCookieName = "org-impers";

	private Post<T extends AjaxStdResponse>(action: string,
		data: any, callback?: (r: T) => void,
		keepBlocking?: boolean,
		endpoint?: string): void {

		if (this._isBusy) {
			console.log("noop... busy...");
			return;
		}
		this._isBusy = true;


		if (this._blk == null) {
			this._blk = new Blocker();
		}

		this._blk.Block();

		var ep = this._cfg.Endpoint;
		if (endpoint != null && endpoint != undefined && endpoint.length > 0)
			ep = endpoint;

		Support.Post<T>(ep + "?action=" + action, data)
			.then((resp: T) => {
				this._isBusy = false;
				if (callback)
					callback(resp);
			})
			.catch((errr) => {
				this._isBusy = false;
				this.Alert(errr);
			})
			.then(() => {
				if (keepBlocking === true) {
					/*
						DON'T UNBLOCK... 
					*/
				} else {
					this._blk.Unblock();
				}
			});

	}





	private Load(): void {

		var req: CL.LoadRequest = {
		};

		this.Post<CL.LoadResponse>("load", req, (resp) => this.LoadCompleted(resp));
	}


	private LoadCompleted(resp: CL.LoadResponse): void {

		this.InstantiateVueApp(resp);
	}




	private GetCSV(): void {

		if (!confirm('You are about to download in CSV format, the current page of results.\r\nContinue?'))
			return;

		console.log("Getting the csv...");

		var req = this.GetLoadRequest();
		this.Post<CL.GetCsvResponse>("get-csv", req,
			(resp) => {
				window.open('/specdev/viewpoint/csvdata/?code=' + resp.Code);
			});
	}


	private GetReport(): void {

		console.log("Generating report...");

		var req = this.GetLoadRequest();

		this.Post<CL.GetCsvResponse>("get-report", req, (resp) => {
			window.open('/specdev/viewpoint/csvdata/report.aspx?code=' + resp.Code);
			// alert('Report Generation was requested. It will be sent to your email address');	
		});

	}


	private GetAggregateHealthBio(): void {


		this._mdl.Display({
			Title: "Aggregate Health Bio Report • Supply Emails",
			DomSelector: "#pnlCsvEmail",
			Buttons: [
				{
					Text: 'Cancel',
					Class: 'btn btn-danger btn-md'
				},
				{
					Text: 'Generate',
					Class: 'btn btn-success btn-md',
					Callback: (evt) => {
						console.log("Generate requested");
						this.GetAggregateHealthBio_go();
					}
				}
			],
		});
	}


	private GetAggregateHealthBio_go(): void {

		var c: CL.CompanyDTO = this._vue.Company;

		console.log("Generating aggregate Health Bio for", c.Name);

		var cliName = c.Name;

		var req: CL.BatchGenerationRequest = {
			ClientName: cliName,
			Emails: this._vue.AggrBioCsvEmails,
		};

		this.Post<CL.BatchGenerationResponse>("bulk-bio", req, (resp) => {

			if (resp.Ok) {
				window.open('/specdev/viewpoint/csvdata/report.aspx?&code=' + resp.Code);
			} else {
				alert('Error: ' + resp.Msg);
			}

			/* CLEARING THE LIST OF EMAILS */
			this._vue.AggrBioCsvEmails = '';

			// alert('Report Generation was requested. It will be sent to your email address');	
		}, null, '/specdev/viewpoint/services/bios.aspx');

	}




	private Filter(): void {
		var req = this.GetLoadRequest();
		this.Post<CL.LoadResponse>("load", req, (resp) => this.FilterCompleted(resp));
	}


	private GetLoadRequest(): CL.LoadRequest {

		var pi: CL.PageInfo = this._vue.PageInfo as CL.PageInfo;

		var pg = pi.Current;
		var srt = this._vue.Sort;

		var req: CL.LoadRequest = {
			Filters: (this._vue) ? this._vue.CurrentFilters : null,
			Page: pg,
			Sort: srt,
			PageSize: pi.RPP,
			SearchString: (this._vue) ? this._vue.SearchString : null,
			ClassOrProgram: this._vue.ClassOrProgramSelected,
			SimpleDateRange: this._vue.SimpleDateRange,
		};

		return req;
	}



	private FilterCompleted(resp: CL.LoadResponse): void {

		this.SetVueData(resp.Compos,
			resp.Company, resp.Filters, resp.PageInfo,
			resp.Sort, resp.SearchString, resp.ClassOrPrograms,
			this._vue.ClassOrProgramSelected, resp.ChildOrgs,
			this._vue.ChildOrgSelected,
			resp.StudentNotesRead,
			resp.IsViewpointAdmin, resp.SimpleDateRange,
			resp.CanUploadOnBehalf,
			this._vue);
	}



	private NoteIsNew(n: CL.StudentNoteDTO): boolean {

		if ((n as any).__inserted) return false;

		var snr = (this._vue.StudentNotesRead as CL.StudentNoteReadDTO[]);

		var result = snr.filter(s => s.StudentID == n.StudentID);

		if (result == null || result.length == 0) return true;

		var r = result[0];

		if (!r.LatestNoteRead) return true;

		var areNew = r.LatestNoteRead < n.RecordID

		return areNew;

	}



	private AreNewNotes(studentID: number): boolean {

		var snr = (this._vue.StudentNotesRead as CL.StudentNoteReadDTO[]);

		var result = snr.filter(s => s.StudentID == studentID);

		if (result == null || result.length == 0) return false;

		var rval = result[0].AreNewNotes;

		return rval;
	}



	private _lastDateRange: string = '';
	private WatchSimpleDateRange(b: any, a: any) {
		/* WE WANT TO CONFIRM BEFORE MAKING A SEARCH 
		WITH A LARGE DATE-RANGE.

		IF CONFIRM IS NEGATIVE, WE NEED TO PREVENT A SEARCH 
		FROM TRIGGERING AT ALL, AND WE NEED TO RESTORE THE VALUE
		TO A PREVIOUS STATE.
		 */
		if (this._lastDateRange == b) return;

		if (b == "9999") {
			var ok = confirm("are you sure ?");
			if (!ok) {
				this._vue.SimpleDateRange = a;
				return;
			}
		}

		this.Filter();
		this._lastDateRange = b;
	}




	public ShowVacs(f: CL.RequirementFileDTO): void {
		var anyO = (f as any);
		var show = anyO.ShowVacs;
		if (show == undefined) {
			this._vue.$set(f, 'ShowVacs', true);

			/* WE ARE DYNAMICALLY CREATING 2 PROPERTIES ON THE OBJECT, 
			FOR EASE OF CONSUMING THE 2 DIFFERENT VACCINE DATE-TYPES 
			(VACCINE / TITER)
			*/
			var vaccs = f.Vaccines.filter(v => v.DateType == 0);
			var titrs = f.Vaccines.filter(v => v.DateType != 0);

			this._vue.$set(f, 'Vacs', vaccs);
			this._vue.$set(f, 'Titrs', titrs);

		} else {
			anyO.ShowVacs = !anyO.ShowVacs;
		}
	}


	private GenerateBio(c: CL.SuperCompoDTO): void {
		if (c.Person != null && c.Person.Tests != null
			&& c.Person.Tests.length > 0) {
			var refid = c.Person.Tests[0].OrderID;
			window.open("/Specdev/Viewpoint/Services/Bios.aspx?action=individual-bio&ref-id=" + refid);
		}
	}


	private GetSortByName(): string
	{
		if(!this._vue || !this._vue.Sort)
			return '';
		
		var si = this._vue.Sort;
		if (si.SortBy != CL.SortBy.Name
			&& si.SortBy != CL.SortBy.NameInv
		)
			return '';
		
		var rval = (si.SortBy == CL.SortBy.Name
		? "LName" 
		: "FName")
		+" "
		+(si.SortAsc? "A-Z": "Z-A");

		return rval;
	}

	private InstantiateVueApp(resp: CL.LoadResponse): void {

		var vueData: any = {};

		var impersonatedOrg: string = CL.CookieMan.GetCookie(this._impersCookieName);

		this.SetVueData(resp.Compos, resp.Company,
			resp.Filters, resp.PageInfo, resp.Sort,
			resp.SearchString, resp.ClassOrPrograms, '',
			resp.ChildOrgs, impersonatedOrg,
			resp.StudentNotesRead,
			resp.IsViewpointAdmin, resp.SimpleDateRange,
			resp.CanUploadOnBehalf,
			vueData);

		this._vue = new Vue({
			el: this._cfg.AppContainer,
			data: vueData,
			computed: {
			},
			watch: {
				SimpleDateRange: (b: any, a: any) => this.WatchSimpleDateRange(b, a),
			},
			methods: {
				SortByName: ()=>this.SortByName(),
				GetSortByName: ()=>this.GetSortByName(),
				GenerateBio: (c: any) => this.GenerateBio(c),
				ToggleReqs: (f: any) => this.ToggleRequirements(f),
				GetRequirementInfo: (o: number, n: string) => this.GetRequirementInfo(o, n),
				ShowVacs: (f: any) => this.ShowVacs(f),
				ApproveAll: (obj: any) => this.ToggleAll(CL.WhatToggle.Approve),
				UnapproveAll: (obj: any) => this.ToggleAll(CL.WhatToggle.Unapprove),
				ArchiveAll: (obj: any) => this.ToggleAll(CL.WhatToggle.Archive),
				UnarchiveAll: (obj: any) => this.ToggleAll(CL.WhatToggle.Unarchive),
				ClassifyAll: (obj: any) => this.ToggleAll(CL.WhatToggle.Classify),
				ShareAll: (obj: any) => this.ToggleAll(CL.WhatToggle.Share),

				ApproveAllGo: () => this.ApproveAllGo(),
				UnapproveAllGo: () => this.UnapproveAllGo(),
				ArchiveAllGo: () => this.ArchiveAllGo(),
				UnarchiveAllGo: () => this.UnarchiveAllGo(),
				ClassifyAllGo: (c: CL.ClassifDto) => this.ClassifyAllGo(c),
				ShareAllGo: (s: CL.ShareDto) => this.ShareAllGo(s),

				FilterChanged: (id: number) => this.FilterChanged(id),
				ClassOrProgramChanged: (sender: any) => this.Filter(),
				ChildOrgChanged: (sender: any) => this.ChildOrgChanged(),

				GetFileStatus: (s: CL.FileStatus): string => {
					return CL.FileStatus[s];
				},

				GoToPrev: () => this.GoToPrev(),
				GoToNext: () => this.GoToNext(),
				GoToPage: (p: number) => this.GoToPage(p),


				PopFileOpen: (file: CL.RequirementFileDTO) =>
					this.PopFileOpen(file),

				SortBy: (s: CL.SortBy) => this.SortBy(s),


				SetClassification:
					(classif: CL.ClassifDto) => this.SetClassification(classif),

				GetHealthPortal: (c: CL.SuperCompoDTO) => this.GetHealthPortal(c),
				IsHealthPortalOrdered: (c: CL.SuperCompoDTO) => this.IsHealthPortalOrdered(c),

				GetStudentNotes: (person: any) => this.GetStudentNotes(person),
				SaveStudentNote: () => this.SaveStudentNote(),
				ClearStudentNote: (note: CL.StudentNoteDTO) => this.ClearStudentNote(note),
				ClearStudentNoteFile: (file: CL.StudentFileDTO) => this.ClearStudentNoteFile(file),
				AreNewNotes: (personID: number) => this.AreNewNotes(personID),
				NoteIsNew: (n: CL.StudentNoteDTO) => this.NoteIsNew(n),

				DisplayTest: (t: CL.TestOrdered) => this.DisplayTest(t),

				ChangePageSize: (obj: any) => this.ChangePageSize(obj),

				Approve: (f: CL.RequirementFileDTO) => this.ApproveFile(f),
				// this.UpdateFileStatus(f, CL.FileStatus.Approved),
				ApproveNot: (f: CL.RequirementFileDTO) => this.UpdateFileStatus(f, CL.FileStatus.NotApproved),
				SeriesInProcess: (f: CL.RequirementFileDTO) => this.UpdateFileStatus(f, CL.FileStatus.SeriesInProcess),

				ConfirmApproveFile: () => this.ConfirmApproveFile(),
				CancelApproveFile: () => this.CancelApproveFile(),

				ChangeExpDate: (evt: any, f: CL.RequirementFileDTO) =>
					this.ChangeExpDate(evt, f),

				SendMessageToStudent: () => this.SendMessageToStudent(),
				ToggleStudentMessages: () => this.ToggleStudentMessages(),
				ToggleApprovalLogs: () => this.ToggleApprovalLogs(),

				Search: () => this.Search(),

				GetCSV: () => this.GetCSV(),
				GetReport: () => this.GetReport(),
				GetAggregateHealthBio: () => this.GetAggregateHealthBio(),

				UploadOnBehalfBegin: (file: CL.StudentFileDTO) => this.UploadOnBehalfBegin(file),
				UploadOnBehalfCancel: () => this.UploadOnBehalfCancel(),
				UploadOnBehalfSuccess: ()=> this.UploadOnBehalfSuccess(),
			},
			filters: {
				uppercase: (v: string) => { return (v + "").toUpperCase() },
			}
		});

		vueData.AppReady = true;

		console.log("Vue Instantiated for panel [%s]", this._cfg.AppContainer);
	}


	private _to2: number;
	private _lastSearch: string;
	private Search(): void {

		if (this._vue.SearchString == this._lastSearch) return;
		this._lastSearch = this._vue.SearchString;
		this.Filter();

		// clearTimeout(this._to2);

		// this._to2 = setTimeout(() => {

		//   this.Filter(); 

		// }, 500);

	}



	private ToggleApprovalLogs(): void {
		this._vue.ShowFileLogs = !this._vue.ShowFileLogs;
	}



	private ToggleStudentMessages(): void {

		if (this._vue.ShowStudentMessages) {
			this._vue.ShowStudentMessages = false;
			return;
		}

		this.ShowStudentMessages();
	}


	private ShowStudentMessages(): void {

		var req: CL.GetMessagesRequest = {
			UserID: this._vue.CurrPerson.ContactID,
		};

		this.Post<CL.GetMessagesResponse>(
			'get-msg', req, (res) => this.GetStudentMessagesCompleted(res));

	}


	private GetStudentMessagesCompleted(res: CL.GetMessagesResponse): void {
		this._vue.StudentMessages = res.Messages;
		this._vue.ShowStudentMessages = true;
	}




	private SendMessageToStudent(): void {

		var req: CL.SendMessageRequest = {
			Message: this._vue.MessageToStudent,
			UserID: this._vue.CurrPerson.ContactID,
			UserEmail: this._vue.CurrPerson.Email,
		};


		this.Post<CL.SendMessageResponse>(
			'send-msg', req, (res) => this.SendMessageToStudentCompleted(res));


	}

	private SendMessageToStudentCompleted(res: CL.SendMessageResponse): void {
		this._vue.MessageToStudent = null;
		this.Alert("Message Sent!");

		if (this._vue.ShowStudentMessages)
			this.ShowStudentMessages();
	}



	private ChangeExpDate(evt: any, f: CL.RequirementFileDTO) {
		var dateValue: string = $(evt.target).val();
		this.UpdateFile(f, null, dateValue, true);
	}


	private CancelApproveFile() {

		this._vue.DocApproval = false;
		this._vue.DocApprovalFile = null;
		this._vue.DocApprovalMessage = null;

	}


	private ConfirmApproveFile() {
		this.UpdateFile(this._vue.DocApprovalFile,
			CL.FileStatus.Approved, null, null,
			(ok: boolean) => {

				console.log('completed with status ok: ', ok)
				if (!ok) return;

				/* WE ARE DONE WITH THE APPROVAL CONFIRMATION, CLOSE IT */
				this.CancelApproveFile();
			});
	}


	private ApproveFile(f: CL.RequirementFileDTO) {

		if (f.Status == CL.FileStatus.ApprovalPending) {
			alert("File is already waiting on Approval");
			return;
		}
 
		/* CAN'T APPROVE A FILE IF IT'S APPROVED, OR PENDING, 
		AND THE USER IS NOT A VIEWPOINT ADMIN.
		 */
		if (!this._vue.IsViewpointAdmin
			&& ( f.Status == CL.FileStatus.Pending
			|| f.Status == CL.FileStatus.Approved)
		) {
			alert("Approval requests can only be made for documents that have been rejected");
			return;
		}

		this._vue.DocApproval = true;
		this._vue.DocApprovalFile = f;
		this._vue.DocApprovalMessage = null;
	}


	private UpdateFileStatus(f: CL.RequirementFileDTO, status: CL.FileStatus) {
		this.UpdateFile(f, status);
	}

	private UpdateFile(f: CL.RequirementFileDTO,
		newFileStatus?: CL.FileStatus,
		expDate?: string, updateExpDate?: boolean,
		callback?: (ok: boolean) => void) {

		var req: CL.UpdateFileRequest = {
			File: f,
			NewFileStatus: newFileStatus,
			ExpDate: expDate,
			UpdateExpDate: updateExpDate,

			PersonEmail: this._vue.CurrPerson.Email,

			RequestMessage: this._vue.DocApprovalMessage,
		};

		this.Post<CL.UpdateFileResponse>(
			'mod-file', req, (res) => {
				this.ApproveFileCompleted(res);
				if (callback) callback(res.Ok);
			});

	}


	private ApproveFileCompleted(res: CL.UpdateFileResponse) {
		for (var n = 0; n < this._vue.HealthFiles.length; n++) {
			var fi: CL.RequirementFileDTO = this._vue.HealthFiles[n];
			if (fi.ID == res.File.ID) {
				this._vue.HealthFiles.splice(n, 1, res.File)
				// fi.Status = res.File.Status;
				// fi.StatusDate = res.File.StatusDate;
				break;
			}
		}
	}



	private ChangePageSize(obj: any) {
		var pageSize: string = $(obj.target).val();

		(this._vue.PageInfo as CL.PageInfo).RPP = parseInt(pageSize);

		this.Filter();
	}


	private DisplayTest(t: CL.TestOrdered): void {

		/* OPENING THE FILE IN A NEW TAB.
			 ADDING A RANDOM PARAMETER TO ENSURE THE PDF IS NOT RETRIEVED FROM THE CACHE.
		 */
		if (t.PdfDocument == null || t.PdfDocument == undefined) {
			this.Alert("There is no report to view. Please contact support for assistance.");
			console.log("No PDF document");
			return;
		}
		var seed = this.GetRandomSeed();
		window.open(t.PdfDocument + "?rseed=" + seed, "_blank");

		t.IsNew = false;

		var req: CL.SetReadRequest = {
			RecordID: t.OrderID
		}

		this.Post<CL.SetReadResponse>(
			"set-read", req, null
		);


	}

	private UploadOnBehalfBegin(file: CL.StudentFileDTO): void {
		this._vue.UploadOnBehalfStudentFile = null;

		this._vue.$nextTick(()=>{
			this._vue.UploadOnBehalfStudentFile = file;
		});
	}

	private UploadOnBehalfCancel(): void {
		this._vue.UploadOnBehalfStudentFile = null;
	}

	private UploadOnBehalfSuccess(): void {
		this._vue.UploadOnBehalfStudentFile = null;

		console.log("Operation succeeded");

		/* RELOADING THE USER'S HEALTH PORTAL */
		this.GetHealthPortal(this._vue.CurrCompo);
	}


	private GetStudentNotes(person: any) {

		var req: CL.LoadStudentNotesRequest = {
			StudentID: person.ContactID,
		};

		this._vue.StudentNotes = [];
		this._vue.NotesForPersonID = person.ContactID;

		var studentName = person.FName + ' ' + person.LName;


		this.Post<CL.LoadStudentNotesResponse>("load-notes", req,
			(res) => {
				this.GetStudentNotesCompleted(res, studentName)
			});

	}

	private GetStudentNotesCompleted(resp: CL.LoadStudentNotesResponse,
		studentName: string) {

		this._vue.StudentNotes = resp.Notes;

		this._mdl.Display({
			Title: "Notes for " + studentName,
			DomSelector: "#pnlStudentNotes",
			Buttons: [
				{
					Text: 'DONE',
					Class: 'btn blue btn-lg btn-block'
				}
			],
		});

	}

	private SaveStudentNote() {

		var req: CL.InsertStudentNoteRequest = {
			StudentID: this._vue.NotesForPersonID,
			Note: this._vue.StudentNotesText,
			FilePath: null,
			Files: this._vue.StudentNotesFiles,
		};

		this.Post<CL.InsertStudentNoteResponse>("insert-note", req,
			(res) => this.SaveStudentNoteCompleted(res));

	}


	private SaveStudentNoteCompleted(resp: CL.InsertStudentNoteResponse) {

		var n = (resp.Note as any);
		n.__inserted = true;

		this._vue.StudentNotes.unshift(n);

		/* CLEARING THE PREVIOUS NOTE.
		*/
		this._vue.StudentNotesText = null;

		/* CLEARING THE STUDENT NOTE FILES, WITHOUT CREATING A NEW OBJECT	*/
		this._vue.StudentNotesFiles.splice(0, this._vue.StudentNotesFiles.length);
	}



	private ClearStudentNote(note: CL.StudentNoteDTO) {

		var ok = confirm('Are you sure you want to delete this Note (with all its files) ?');
		if (!ok) return;

		var req: CL.DeleteStudentNoteRequest = {
			NoteID: note.RecordID,
		};

		this.Post<CL.DeleteStudentNoteResponse>("delete-note", req,
			(res) => {
				(note as any).RecordID = -1;
			});

	}





	private ClearStudentNoteFile(file: CL.StudentFileDTO) {

		var ok = confirm('Are you sure you want to delete file ' + file.Name + ' ?');
		if (!ok) return;

		var req: CL.DeleteStudentNoteFileRequest = {
			FileID: file.RecordID
		};

		this.Post<CL.DeleteStudentNoteFileResponse>("delete-file", req,
			(res) => {
				file.RecordID = -1;
			});
	}



	private IsHealthPortalOrdered(c: CL.SuperCompoDTO): boolean {
		/*
		https://bluetonemedia.teamwork.com/app/tasks/22774482		
		*/
		// console.log("testing for health portal order");
		return c.HealthPortalStatus != CL.FileFlag.NoHealthPortal;
	}

	// private _currPerson: CL.PersonInfo;
	private GetHealthPortal(c: CL.SuperCompoDTO): void {

		this._vue.CurrCompo = c;
		this._vue.CurrPerson = c.Person;
		// this._currPerson = c.Person;

		/* CLEARING THE MESSAGES INFORMATION
			 SO IT DOES NOT SHOW UP / FLICKER 
			 WHEN THE HEALTH PORTAL SHOWS UP.
		*/
		this._vue.MessageToStudent = null;
		this._vue.StudentMessages = [];
		this._vue.ShowStudentMessages = false;

		var req: CL.GetFilesRequest = {
			ReferenceOrderID: c.Person.OrderID,
		};

		this.Post<CL.GetFilesResponse>("files", req,
			(res) => this.GetHealthPortalCompleted(res));

	}


	private GetHealthPortalCompleted(res: CL.GetFilesResponse): void {

		this._vue.HealthFiles = res.Files;
		this._vue.HealthFilesLogs = res.ApprovalLogs;
		this._vue.HealthFilesReqs = res.Requirements;

		this._mdl.Display({
			Title: this._vue.CurrPerson.FName + ' ' + this._vue.CurrPerson.LName
				+ ' / ' + this._vue.CurrPerson.Email,
			DomSelector: this._cfg.PanelPortalSelector,
			Buttons: [
				{
					Text: 'DONE',
					Class: 'btn blue btn-lg btn-block'
				}
			],
			OnVisibility: (viz) => {
				/* MAKING SURE THE DOC APPROVAL PANEL GETS CLOSED TOO */
				this._vue.DocApproval = false;
			},
		});
	}



	private ToggleRequirements(f: any) {
		if (f.ShowReqs == undefined) {
			Vue.set(f, 'ShowReqs', false);
		}
		f.ShowReqs = !f.ShowReqs;
	}

	private GetRequirementInfo(orgID: number, reqName: string): string {

		if (!CL.Helper.HasData(reqName)) return null;
		reqName = reqName.toLowerCase().trim();

		var a: any[] = this._vue.HealthFilesReqs;

		var filt = a.filter(b => {
			var rn = b.Name;
			if (!CL.Helper.HasData(rn)) return rn = '';
			rn = rn.toLowerCase().trim();
			var isIt = b.SchoolID == orgID && reqName == rn;
			return isIt;
		})

		if (filt != null && filt.length > 0) return filt[0].Description;

		return null;
	}



	// private GetPortfalFileHasReadBadge(f: CL.RequirementFileDTO): boolean {
	//   var badges: CL.BadgeDTO[] = this._vue.HealthFilesBadges;

	//   for (var n = 0; n < badges.length; n++) {
	//     if (badges[n].OrderID == f.ID) return true;
	//   }
	//   return false;
	// }

	// private GetOrderHasReadBadge(
	//   t: CL.TestOrdered,
	//   badges: CL.BadgeDTO[]
	// ): boolean {

	//   for (var n = 0; n < badges.length; n++) {
	//     if (badges[n].OrderID == t.OrderID) return true;
	//   }
	//   return false;
	// }





	private _sortIteration : number =0;
	private SortByName(){
		var si: CL.SortInfo = this._vue.Sort;

		switch(this._sortIteration){
			case 0:
				si.SortBy = CL.SortBy.Name;
				si.SortAsc = true;
				break;

			case 1:
				si.SortBy = CL.SortBy.NameInv;
				si.SortAsc = true;
				break;
					
			case 2:
				si.SortBy = CL.SortBy.Name;
				si.SortAsc = false;
				break;
						
			case 3:
				si.SortBy = CL.SortBy.NameInv;
				si.SortAsc = false;
				break;
		}
		
		this._sortIteration++;
		if (this._sortIteration==4)this._sortIteration =0;
		
		this.Filter();
	}


	private SortBy(s: CL.SortBy) {

		var si: CL.SortInfo = this._vue.Sort;

		if (si.SortBy == s) {
			si.SortAsc = !si.SortAsc;
		} else {
			si.SortBy = s;
			si.SortAsc = true;
		}

		this.Filter();
	}


	private GoToPrev(): void {
		var pi = (this._vue.PageInfo as CL.PageInfo);
		this.GoToPage(pi.Current - 1);
	}

	private GoToNext(): void {
		var pi = (this._vue.PageInfo as CL.PageInfo);
		this.GoToPage(pi.Current + 1);
	}

	private GoToPage(num: number): void {

		var pi: CL.PageInfo = this._vue.PageInfo;

		if (num == pi.Current)
			return;


		pi.Current = num;

		this.Filter();
	}


	private GetPages(pi: CL.PageInfo): number[] {

		var pageSpan = 4;

		var curr = pi.Current;
		var left = curr - pageSpan;
		var right = curr + pageSpan;

		if (left < 0) left = 0;
		if (right > pi.Total) right = pi.Total;


		var rval: number[] = [];
		for (var n = left; n <= right; n++) {
			rval.push(n);
		}

		return rval;
	}


	private GetRandomSeed() {
		var seed = (new Date()).getTime() + "_" + Math.round(Math.random() * 1000);
		return seed;
	}



	private PopFileOpen(file: CL.RequirementFileDTO): void {

		/* OPENING THE FILE IN A NEW TAB.
			 ADDING A RANDOM PARAMETER TO ENSURE THE PDF IS NOT RETRIEVED FROM THE CACHE.
		 */
		var seed = this.GetRandomSeed();
		window.open(file.Path + "?rseed=" + seed, "_blank");

		file.IsNew = false;

		var req: CL.SetReadRequest = {
			RecordID: file.ID,
		}

		this.Post<CL.SetReadResponse>(
			"set-read", req, (resp) => this.PopFileOpenCompleted(resp)
		);
	}

	private PopFileOpenCompleted(resp: CL.SetReadResponse): void {
	}



	// private ClassOrProgramChanged(): void {

	// 	this.S
	// 	var searchClass = ddn.target.value;
	// 	this.Search()


	// 	console.log("Triggered change:", o, classOrProgram);
	// }

	private _to1: number;
	private FilterChanged(id: number): void {

		/*
		PREVENTING THAT SOME OPPOSITES FILTERS ARE SELECTED.
		SO IF COMPLETED IS SELECTED, IN-PROCESS WILL BE DESELECTED, 
		AND VICE VERSA.
		*/

		if (id == CL.WhatFilter.Completed) {
			this._vue.CurrentFilters[CL.WhatFilter.InProcess] = false;
		}

		if (id == CL.WhatFilter.InProcess) {
			this._vue.CurrentFilters[CL.WhatFilter.Completed] = false;
		}

		if (id == CL.WhatFilter.Clear) {
			this._vue.CurrentFilters[CL.WhatFilter.Hits] = false;
		}

		if (id == CL.WhatFilter.Hits) {
			this._vue.CurrentFilters[CL.WhatFilter.Clear] = false;
		}

		if (id == CL.WhatFilter.Compliant) {
			this._vue.CurrentFilters[CL.WhatFilter.NotCompliant] = false;
		}

		if (id == CL.WhatFilter.NotCompliant) {
			this._vue.CurrentFilters[CL.WhatFilter.Compliant] = false;
		}

		clearTimeout(this._to1);

		this._to1 = setTimeout(() => {
			this.Filter();
		}, 1000);
	}


	private ApproveAllGo(): void {
		this.MarkAll(CL.WhatToggle.Approve);
	}
	private UnapproveAllGo(): void {
		this.MarkAll(CL.WhatToggle.Unapprove);
	}

	private ArchiveAllGo(): void {
		this.MarkAll(CL.WhatToggle.Archive);
	}
	private UnarchiveAllGo(): void {
		this.MarkAll(CL.WhatToggle.Unarchive);
	}

	private ClassifyAllGo(c: CL.ClassifDto): void {
		this.MarkAll(CL.WhatToggle.Classify, c);
	}

	private ShareAllGo(shareWith: CL.ShareDto): void {
		this.MarkAll(CL.WhatToggle.Share, null, shareWith);
	}


	private MarkAll(
		toggle: CL.WhatToggle,
		classif?: CL.ClassifDto,
		shareWith?: CL.ShareDto) {

		var ids: number[] = this.GetTogglesSelected(toggle);

		if (ids.length == 0) return;

		var req: CL.MarkAllRequest = {
			IDs: ids,
			What: toggle,
			Classif: classif,
			ShareWith: shareWith,
		};

		this.Post<CL.MarkAllResponse>("mark-all", req,
			(resp) => this.MarkAll_Completed(resp), true);
	}



	private MarkAll_Completed(r: CL.MarkAllResponse): void {
		/* RE-LOAD THE CURRENT PAGE SO THE CHANGES 
			 WE JUST MADE ARE REFLECTED !
		 */
		this.Filter();
	}



	// private ShareAllGo(): void {

	//   var ids: number[] = this.GetTogglesSelected(CL.WhatToggle.Share);

	//   if (ids.length == 0) return;

	//   var req: CL.MarkAllRequest = {
	//     IDs: ids,
	//     What: toggle,
	//     Classif: classif,
	//   };

	//   this.Post<CL.MarkAllResponse>("mark-all", req,
	//     (resp) => this.MarkAll_Completed(resp)
	//   );

	//   // this.Confirm("", (conf) => {
	//   //   if (!conf) return;
	//   //   this.ShareAllGoooo();
	//   // });
	// }






	private ToggleAll(toggle: CL.WhatToggle): void {

		var curr: boolean = this._vue.CurrentToggles[toggle];

		for (var n = 0; n < this._vue.Compos.length; n++) {
			this._vue.Compos[n].Toggler[toggle] = curr;
		}
	}


	private SetClassification(classif: CL.ClassifDto): void {
		this._vue.CurrentClassif = classif.Name;
	}


	private GetTogglesSelected(toggle: CL.WhatToggle): number[] {
		var ids: number[] = [];

		for (var n = 0; n < this._vue.Compos.length; n++) {

			var dto: CL.SuperCompoDTO = this._vue.Compos[n];

			var isTrue = (dto as any).Toggler[toggle];

			if (isTrue) {

				/*
				WE ARE TOGGLING NOT ONLY THE LATEST MOST ORDER, 
				BUT ALL THE ORDERS ASSOCIATED WITH THE USER.

				SO ARCHIVE WILL NOT ONLY ARCHIVE THE "LEADING" ORDER, 
				BUT OTHERS AS WELL. 

				ALTHOUGH MAKING IT ONLY ON THE "LEADING" WOULD BE ENOUGH,
				WE ARE MAKING IT ON THE OTHERS AS WELL WITH THE HOPE
				TO HAVE GREATER CONSISTENCY ON THE RECORDS INFORMATION.

				*/

				ids.push(dto.Person.OrderID);

				for (var m = 0; m < dto.Person.Tests.length; m++) {
					if (isTrue) ids.push(dto.Person.Tests[m].OrderID);
				}

			}


		}

		return ids;
	}




	private GetDefaultToggles(max: number,
		def?: boolean[]): boolean[] {

		var arr: boolean[] = [];
		for (var m = 0; m < max; m++) {

			var value = false;
			if (def && def[m] == true) value = true;

			arr.push(value);
		}
		return arr;
	}



	public ChildOrgChanged(): void {
		CL.CookieMan.SetCookie(this._impersCookieName, this._vue.ChildOrgSelected);
		this.Filter();
	}







	private SetVueData(
		compos: CL.SuperCompoDTO[],
		company: CL.CompanyDTO,
		filters: boolean[],
		pageInfo: CL.PageInfo,
		sort: CL.SortInfo,
		searchString: string,
		classOrPrograms: string[],
		classOrProgramSelected: string,
		childOrgs: string[],
		childOrgSelected: string,
		studentNotesRead: CL.StudentNoteReadDTO[],
		isViewpointAdmin: boolean,
		simpleDateRange: string,
		canUploadOnBehalf: boolean, 
		vueData: any): void {

		for (var n = 0; n < compos.length; n++) {
			/*
				ADDING A PROPERTY ON THE FLY TO THIS OBJECT
				SO IT CAN BE USED FROM THE FRONT END
			 */
			(compos[n] as any).Toggler = this.GetDefaultToggles(this._maxToggles);
		}


		vueData.Compos = compos;

		vueData.Company = company;
		vueData.ClassOrPrograms = classOrPrograms;
		vueData.ChildOrgs = childOrgs;
		vueData.CurrentClassif = null;

		vueData.CurrentToggles = this.GetDefaultToggles(this._maxToggles);
		vueData.CurrentFilters = this.GetDefaultToggles(
			this._maxFilters, filters);

		vueData.PageInfo = pageInfo;
		vueData.Pages = this.GetPages(pageInfo);
		vueData.Sort = sort;
		vueData.HealthFiles = [];
		vueData.HealthFilesLogs = [];
		vueData.HealthFilesReqs = [];

		vueData.DocApproval = false;
		vueData.DocApprovalFile = null;
		vueData.DocApprovalMessage = null;

		vueData.MessageToStudent = null;
		vueData.StudentMessages = [];
		vueData.ShowStudentMessages = false;
		vueData.ShowFileLogs = false;
		vueData.SearchString = searchString;
		vueData.ClassOrProgramSelected = classOrProgramSelected;

		vueData.StudentNotesText = '';
		vueData.StudentNotes = [];
		vueData.StudentNotesFiles = [];
		vueData.StudentNotesRead = studentNotesRead;

		vueData.UploadOnBehalfStudentFile = null;

		{
			/* TESTING IF THE CHILD ORG SELECTED ACTUALLY EXISTS ON THE LIST
				 OF POSSIBLE CHILD ORGS FOR THE CURRENT USER.
			*/
			if (childOrgSelected) {
				var childOrgMatch = childOrgs.some(fn => {
					var matches = fn.toLowerCase() == childOrgSelected.toLowerCase();
					return matches;
				});
				if (!childOrgMatch) {
					console.log("Child org not found: ", childOrgSelected);

					/* REMOVING THE COOKIE ALTOGETHER */
					CL.CookieMan.EraseCookie(this._impersCookieName);

					childOrgSelected = '';
				}
			} else {
				childOrgSelected = '';
			}

			vueData.ChildOrgSelected = childOrgSelected;

			vueData.IsViewpointAdmin = isViewpointAdmin;
			vueData.CanUploadOnBehalf = canUploadOnBehalf;
			vueData.SimpleDateRange = simpleDateRange;
			this._lastDateRange = simpleDateRange;


			vueData.CurrPerson = null;
			vueData.AggrBioCsvEmails = null;

			/* SET AppReady VALUE TO FALSE, ONLY IF THE APP IS NOT READY 
			FROM A PREVIOUS TRIP.
			*/
			if (!vueData.AppReady)
				vueData.AppReady = false;

		}

	}




	private Alert(msg?: string): void {
		if (this._cfg.AlertCallback) {
			this._cfg.AlertCallback(msg);
		} else {
			alert(msg);
		}
	}


	private Confirm(msg?: string,
		callback?: (rval: boolean) => void): void {

		var result = confirm(msg);
		if (callback) callback(result);


		// if (this._cfg.) {
		//   this._cfg.AlertCallback(msg);
		// } else {
		//   alert(msg);
		// }
	}


	public Setup(cfg: CL.CartCfg): void {

		if (cfg == null) {
			throw new Error("Missing config parameter");
		}

		this._cfg = cfg;

		this.Load();
	}



}


// WEBPACK FOOTER //
// ./js/TS_Dashboard.ts